import { ValidationProps } from 'ui/common/validation/types';
import { validateComplexValue, validateIfFilledOut } from 'app/area/codetable/item/screen-renderer/screen-validate/helpers';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { ValidationData } from 'app/area/codetable/item/validation/validate';
import { unfilteredOptionsId } from 'app/area/codetable/item/screen-renderer/custom-screens/consequences/constants';

export const validateConsequenceSeverity = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation, options } = validationData;

  const severityValidation = validateComplexValue(ScreenPicker.severity, codeItem, translation);

  const categoryValidation = validateComplexValue(CodeFieldWireKey.category, codeItem, translation);

  const unfilteredCodes = options?.[unfilteredOptionsId]?.codes;

  const containsAvailableOptions = unfilteredCodes?.filter(option => option?.value !== 0)?.length > 0;
  const containsNotSelected = unfilteredCodes?.length > unfilteredCodes?.filter(option => option?.value !== 0)?.length;
  const uomValidationCondition = !!codeItem?.category?.value && containsAvailableOptions && !containsNotSelected
    ? !!codeItem?.uom?.value
    : true;
  const uomValidation = validateIfFilledOut(ScreenPicker.uom, uomValidationCondition, translation);

  return {
    ...severityValidation,
    ...uomValidation,
    ...categoryValidation
  };
};
